module.exports = "pegasus/assets/blocks/column-lp7-basic.png";